export default __webpack_public_path__ + "static/media/Van13.3840bfb6.webp";